import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n/LangContext";

export const CTASection = () => {
  const { t, lang } = useLang();
  const bookingHref = lang === "sv" ? "/boka-tid" : "/en/book-appointment";
  return (
    <section className="px-2 py-16 sm:px-3 lg:px-4 lg:py-20">
      <div className="relative mx-auto w-full max-w-[96rem] overflow-hidden rounded-2xl bg-primary px-8 py-14 text-primary-foreground shadow-elevated sm:rounded-3xl lg:px-16 lg:py-20">
        <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-24 -left-10 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
        <div className="relative max-w-2xl">
          <h2 className="font-display text-3xl font-semibold tracking-tight sm:text-4xl">{t.cta.title}</h2>
          <p className="mt-3 text-base text-primary-foreground/85">{t.cta.subtitle}</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Button asChild variant="onPrimary" size="xl">
              <a href={bookingHref}>{t.cta.primary}</a>
            </Button>
            <Button asChild variant="ghostOnPrimary" size="xl">
              <a href="tel:+46317617700">
                <Phone className="mr-2 h-4 w-4" />
                {t.cta.secondary}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};